import React from "react";
import mediaQuery from "../../utils/mediaQuery";
import OfferDetails from "../../components/OfferDetails/OfferDetails";
import FooterContent from "../../components/FooterContent/FooterContent";
import Button from "../../components/ui/Button/Button";
import styles from "./ConfirmOffer.module.sass";
import appStyles from "../../App.module.sass";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import AjaxSpinner from "../../components/AjaxSpinner/AjaxSpinner";
import AppContext from "../../contexts/appContext";
import gaTags from "./../../utils/ga-tags";
import useChatUrl from "../../hooks/useChatUrl";
import useSticky from "../../hooks/useSticky";

const ChatLink = () => {
  const { callChat } = useChatUrl();

  return (
    <span onClick={() => callChat()} className={styles.chatLink}>
      {" "}
      Clique aqui
    </span>
  );
};

const Options = ({
  savePdfHandler,
  offerConfirmedHandler,
  isDesktop,
  print,
  gaTypeName,
  ibc,
}) => {
  const [ref, sticky] = useSticky(ibc ? 60 : 125);
  return (
    <>
      <label onClick={savePdfHandler} className={styles.pdf}>
        <i className={"icon icon-download"} />
        Salvar em PDF
      </label>
      <div className={styles.divider} />
      <div
        ref={ref}
        className={!isDesktop && !print && sticky ? styles.sticky : ""}
      >
        <Button
          onClick={offerConfirmedHandler}
          className={styles.confirm}
          selected
          data-gacategory={gaTags.categoryFlow}
          data-gatype={`${gaTypeName}`}
          data-gafunc={`${gaTypeName}-Continuar`}
        >
          Quero comprar
        </Button>
      </div>
    </>
  );
};

class ConfirmOffer extends React.Component {
  state = {
    isDesktop: false,
    print: false,
    adminTax: 0,
  };

  static contextType = AppContext;

  componentDidMount() {
    this.setState({
      isDesktop: mediaQuery.watchIfDesktop((e) =>
        this.setState({ isDesktop: e.matches })
      ),
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.print) {
      this.print();
    }
  }

  componentWillUnmount() {
    mediaQuery.unsubscribe();
  }

  savePdfHandler = () => {
    this.setState({
      isDesktop: true,
      print: true,
    });
  };

  offerConfirmedHandler = () => {
    this.context.setContext({
      ...this.context,
      selectedOffer: {
        ...this.context.selectedOffer,
        adminTax: this.state.adminTax,
      },
    });

    this.props.history.push({
      pathname: "/identificacao",
    });
  };

  print() {
    const appRef = document.getElementsByClassName(appStyles.main)[0];
    const width = appRef.offsetWidth;
    const height = appRef.offsetHeight;
    const xOffset = window.scrollX + appRef.getBoundingClientRect().left;
    const yOffset = window.scrollY + appRef.getBoundingClientRect().top;
    html2canvas(appRef, {
      scale: 2,
      width: width,
      height: height,
      x: xOffset,
      y: yOffset,
      logging: false,
    }).then((canvas) => {
      this.setState({
        isDesktop: mediaQuery.query.matches,
        print: false,
      });
      const pdf = new jsPDF("p", "pt", [width, height]);
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 0, 0, width, height);
      pdf.save("download.pdf");
    });
  }

  render() {
    const offer = {
      group: this.context.selectedOffer,
      simulationType: this.context.simulationType,
    };

    const gaTypeName = `${gaTags.typeFlow}&${offer.group.dados.valorParcela}&-&${offer.group.dados.plano.prazo.restante}meses&-&${offer.group.dados.valorCredito}`;

    return (
      <div className={styles.ConfirmOffer}>
        {this.state.print ? <AjaxSpinner loading /> : null}
        <OfferDetails
          isDesktop={this.state.isDesktop}
          offer={offer}
          productType={this.context.product.id}
          adminTax={(value) => this.setState({ adminTax: value })}
        >
          Confirm Offer
        </OfferDetails>
        {!this.state.isDesktop ? (
          <Options
            savePdfHandler={this.savePdfHandler}
            offerConfirmedHandler={this.offerConfirmedHandler}
            isDesktop={this.state.isDesktop}
            gaTypeName={gaTypeName}
            print={this.state.print}
            ibc={this.context.ibc}
          />
        ) : null}
        <FooterContent
          path="/ofertas"
          sticky={!this.state.print && this.state.isDesktop}
          canSticky
          ibc={this.context.ibc}
        >
          {this.state.isDesktop ? (
            <div className={styles.desktopOptions}>
              <Options
                savePdfHandler={this.savePdfHandler}
                offerConfirmedHandler={this.offerConfirmedHandler}
                isDesktop={this.state.isDesktop}
                print={this.state.print}
                gaTypeName={gaTypeName}
                ibc={this.context.ibc}
              />
            </div>
          ) : null}
        </FooterContent>
        {!this.context.ibc && process.env.REACT_APP_DISABLE_CHAT !== 'true' && (
          <p className={styles.chatText}>
            Precisa de ajuda? {<ChatLink />} e continue comprando pelo chat e
            tire suas dúvidas.
          </p>
        )}
      </div>
    );
  }
}

export default ConfirmOffer;
